(function() {
  'use strict';

  // ── FAQ ACCORDION ──
  var faqItems = document.querySelectorAll('.otrk-faq-item');
  faqItems.forEach(function(item) {
    var btn = item.querySelector('.otrk-faq-question');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var isOpen = item.classList.contains('open');
      faqItems.forEach(function(fi) {
        fi.classList.remove('open');
        var b = fi.querySelector('.otrk-faq-question');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
})();
